/* もしもアフィリエイト セッション方式: rd_code の取得と保持
   プロモーションID 7768 / 再訪問有効日数 90日
   来訪時に rd_code を受け取り、カート属性・Cookie・localStorage の3箇所に保存する。
   カート属性を主に使う（注文の note_attributes に残るため Flow から参照できる）。
   Cookie と localStorage は last-click の基準値として持ち、カート属性をこれに追随させる。 */
(function () {
  var KEY = 'msmo_rd_code';
  var DAYS = 90;
  var MAX_LEN = 200;
  var SYNCED = 'msmo_synced';

  function readParam() {
    try {
      return new URLSearchParams(window.location.search).get('rd_code');
    } catch (e) {
      console.warn('[msmo] URLSearchParams 不可', e);
      return null;
    }
  }

  function writeCookie(code) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + DAYS * 864e5);
      document.cookie =
        KEY + '=' + encodeURIComponent(code) +
        ';expires=' + d.toUTCString() +
        ';path=/;SameSite=Lax;Secure';
    } catch (e) {
      console.warn('[msmo] Cookie 書き込み失敗', e);
    }
  }

  function writeLocal(code) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: code, t: Date.now() }));
    } catch (e) {
      console.warn('[msmo] localStorage 書き込み失敗', e);
    }
  }

  function readStored() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
      if (m) return decodeURIComponent(m[1]);
    } catch (e) {}
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      // Cookie は90日で失効する。localStorage は無期限なので同じ期限で揃える
      if (!o || !o.v || Date.now() - o.t > DAYS * 864e5) {
        localStorage.removeItem(KEY);
        return null;
      }
      return o.v;
    } catch (e) {
      return null;
    }
  }

  function writeCartAttribute(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'attributes[' + encodeURIComponent(KEY) + ']=' + encodeURIComponent(code),
      keepalive: true
    }).catch(function (e) {
      console.warn('[msmo] カート属性の書き込み失敗', e);
    });
  }

  var code = readParam();

  if (code) {
    if (code.length > MAX_LEN) {
      console.warn('[msmo] rd_code が長すぎるため保存しない', code.length);
      return;
    }
    // last-click。後から来たコードで常に上書きする
    writeCookie(code);
    writeLocal(code);
    writeCartAttribute(code);
    try { sessionStorage.removeItem(SYNCED); } catch (e) {}
    return;
  }

  // rd_code なしの通常来訪
  var stored = readStored();
  if (!stored) return;

  try { if (sessionStorage.getItem(SYNCED)) return; } catch (e) {}

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var attrs = (cart && cart.attributes) || {};
      // 受領時の書き込みが失敗していた場合と、他アプリに上書きされた場合の修復
      if (attrs[KEY] !== stored) return writeCartAttribute(stored);
      try { sessionStorage.setItem(SYNCED, '1'); } catch (e) {}
    })
    .catch(function (e) {
      console.warn('[msmo] カート取得失敗', e);
    });
})();
